export default __webpack_public_path__ + "static/media/fightTheme.9661fc0d.mp3";